/* eslint-disable no-lone-blocks */
// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {generateSelectionMap} from '../../../shared/components/facets/dealer-hierarchy/helpers';
import {getIsPinTransferEnabled} from '../../../product/shared/services/get-is-pin-transfer-enabled-aor';
import {getTerritories} from '../../../user/shared/repositories/territories';
import {readAmountOfUseRequests} from './get-amount-of-use-requests';
import {readClosingAccount} from './get-close-account';
import {readDuplicatePinPlate} from './get-duplicate-pin-plate';
import {readLaborRateChanges} from './get-labor-rate-changes';
import {readMachineStatusUpdates} from './get-machine-status-updates';
import {readPipCodeRequests} from './get-pip-code-requests';
import {readTcsmSettings} from './tcsm-settings';

const getListOfSelectedDealers = selectedAccounts =>
    Object.keys(selectedAccounts).filter(isSelected => selectedAccounts[isSelected]);

/* eslint-disable complexity */

const getData = (state, selectedDealers, racfId, dispatch) => {

    if (state.showMachineStatus) {

        readMachineStatusUpdates(selectedDealers)(dispatch);

    }

    if (state.showPipCode) {

        readPipCodeRequests(selectedDealers)(dispatch);

    }

    if (state.showLaborRate) {

        readLaborRateChanges(selectedDealers)(dispatch);

    }

    if (state.showSpa) {

        readTcsmSettings(selectedDealers, racfId)(dispatch);

    }

    {

        readClosingAccount(selectedDealers)(dispatch);

    }

    {

        readDuplicatePinPlate(selectedDealers)(dispatch);

    }

    {

        if (getIsPinTransferEnabled('add-amount-of-use')) {

            readAmountOfUseRequests(selectedDealers)(dispatch);

        }

    }

};

/* eslint-enable complexity */

export const readTerritories = (racfId, state) =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const territories = await getTerritories(racfId);

            dispatch({
                territories,
                type: actions.UPDATE_USER_TERRITORIES
            });

            const initializedDealerHierarchy = generateSelectionMap(territories);

            const selectedDealers = getListOfSelectedDealers(initializedDealerHierarchy.selectedAccounts);

            const facets = {
                dealers: selectedDealers,
                ...initializedDealerHierarchy
            };

            dispatch({
                facets,
                type: actions.UPDATE_TCSM_WIP_FACETS
            });

            if (territories.length) {

                getData(state, selectedDealers, racfId, dispatch);

                dispatch({
                    territories,
                    type: actions.UPDATE_TCSM_FILTERED_TERRITORIES
                });

            }

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/tcsm/wip/action-creators/get-territories.js